// extracted by mini-css-extract-plugin
module.exports = {"tab":"use-case-tab_tab__0fCGW","active":"use-case-tab_active__OtR5x"};